import React, { Component } from 'react'
import DropdownButton from 'react-bootstrap/lib/DropdownButton'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import Checkbox from 'react-bootstrap/lib/Checkbox'
import Radio from 'react-bootstrap/lib/Radio'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import * as config from '../config'

class OptionDropdown extends Component {
    handleCheckboxChange = () => {
        this.props.onCollapseChange(!this.props.collapse)
    }

    handleGroupByChange = (e) => {
        const groupBy = e.target.value
        this.props.onGroupByChange(groupBy)
    }

    render() {
        const { collapse, groupBy } = this.props
        const canChangeGroupBy = !config.isProd // TODO remove feature toggle when feature finished

        return (
            <ButtonGroup>
                <DropdownButton id="option-dropdown" title={<i className="fa fa-ellipsis-h" aria-hidden="true"></i>} pullRight noCaret bsStyle="default" className="option-dropdown">
                    <div>
                        <Checkbox
                            checked={collapse}
                            onChange={this.handleCheckboxChange}
                        >
                            Collapse entries to tags
                        </Checkbox>
                    </div>
                    {canChangeGroupBy && collapse &&
                    <div>
                        <span className="group-by">Group by:</span>
                        <FormGroup>
                            <Radio
                                name="group-by"
                                checked={groupBy === 'day'}
                                onChange={this.handleGroupByChange}
                                value="day"
                            >Day</Radio>
                            <Radio
                                name="group-by"
                                checked={groupBy === 'week'}
                                onChange={this.handleGroupByChange}
                                value="week"
                            >Week</Radio>
                        </FormGroup>
                    </div>}
                </DropdownButton>
            </ButtonGroup>
        )
    }
}

export default OptionDropdown


// WEBPACK FOOTER //
// ./src/components/option_dropdown.jsx